<template>
    <v-dialog v-model="dialog" persistent scrollable max-width="800">
        <v-card tile :disabled="loading" :loading="loading">
            <v-toolbar dark dense>
                <v-toolbar-title>
                    EXCESO DE AUTOSEGURO
                </v-toolbar-title>

                <v-spacer />

                <v-toolbar-items>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pt-4">
                <v-row dense>
                    <v-col cols="12">
                        <v-switch v-model="data.self_insurance_excess" class="mt-0 pt-0" label="Exceso de autoseguro"
                            dense />
                    </v-col>

                    <template v-if="data.self_insurance_excess">
                        <v-col v-for="(insured_icd, i) in active_insured_icds" :key="insured_icd.id || `new-${i}`"
                            cols="12">
                            <v-row dense>
                                <v-col cols="12" md="10">
                                    <v-autocomplete v-model="insured_icd.icd_id" :label="`ICD* (${i + 1})`"
                                        :items="icds" :loading="icds_loading" item-value="id" :item-text="getIcdText"
                                        dense />
                                </v-col>

                                <v-col cols="12" md="2" align-self="center">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" text icon x-small color="error"
                                                @click="icdDelete(insured_icd, i)">
                                                <v-icon medium>mdi-close</v-icon>
                                            </v-btn>
                                        </template>

                                        <span v-text="`Eliminar ICD (${i + 1})`" />
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12">
                            <v-btn block dark x-small color="warning" :loading="icds_loading" @click="icdAdd">
                                <v-icon left>mdi-plus</v-icon>
                                Agregar ICD
                            </v-btn>
                        </v-col>
                    </template>

                    <v-col cols="12" class="mt-3">
                        <v-btn block color="success" @click.prevent="submit">
                            Guardar
                            <v-icon right>mdi-content-save</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import Axios from "axios";

import {
    URL_API,
    headersToken,
    msgAlert,
    msgConfirm,
} from "../../control";

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },

        insuredId: {
            type: Number,
            required: true,
        },

        selfInsuranceExcess: {
            type: Boolean,
            default: false,
        },

        insuredIcds: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            login: this.$store.getters.getLogin,

            loading: false,

            data: {
                self_insurance_excess: false,
                insured_icds: [],
            },

            icds: [],
            icds_loading: false,
        };
    },

    computed: {
        dialog: {
            get() {
                return this.value;
            },

            set(value) {
                this.$emit("input", value);
            },
        },

        active_insured_icds() {
            return this.data.insured_icds.filter(
                (insured_icd) => insured_icd.active,
            );
        },
    },

    watch: {
        value(value) {
            if (!value) {
                return;
            }

            this.data.self_insurance_excess = Boolean(
                this.selfInsuranceExcess,
            );

            this.data.insured_icds = this.insuredIcds.map(
                (insured_icd) => ({
                    ...insured_icd,
                    active: Boolean(insured_icd.active),
                }),
            );

            if (this.icds.length === 0) {
                this.getIcds();
            }
        },
    },

    methods: {
        getIcdText(item) {
            return `${item.code} - ${item.name}`;
        },

        async getIcds() {
            this.icds_loading = true;

            try {
                const response = await Axios.get(
                    `${URL_API}/icds`,
                    headersToken(this.login.token),
                );

                this.icds = response.data.data || [];
            } catch (err) {
                this.$swal.fire(
                    msgAlert("error", "No fue posible cargar los ICD"),
                );
            } finally {
                this.icds_loading = false;
            }
        },

        icdAdd() {
            this.data.insured_icds.push({
                id: null,
                active: true,
                insured_id: this.insuredId,
                icd_id: null,
            });
        },

        icdDelete(insured_icd, i) {
            this.$swal
                .fire(
                    msgConfirm(`¿Confirma eliminar el ICD (${i + 1})?`),
                )
                .then((response) => {
                    if (!response.isConfirmed) {
                        return;
                    }

                    if (insured_icd.id === null) {
                        const index = this.data.insured_icds.indexOf(
                            insured_icd,
                        );

                        if (index >= 0) {
                            this.data.insured_icds.splice(index, 1);
                        }

                        return;
                    }

                    insured_icd.active = false;
                });
        },

        async submit() {
            const invalid_icd = this.data.insured_icds.some(
                (insured_icd) =>
                    insured_icd.active && !insured_icd.icd_id,
            );

            if (invalid_icd) {
                this.$swal.fire(
                    msgAlert("error", "Selecciona todos los ICD activos"),
                );

                return;
            }

            const confirm = await this.$swal.fire(
                msgConfirm(
                    "¿Confirma actualizar el exceso de autoseguro?",
                ),
            );

            if (!confirm.isConfirmed) {
                return;
            }

            this.loading = true;

            try {
                const response = await Axios.patch(
                    `${URL_API}/insureds/${this.insuredId}/self_insurance_excess`,
                    {
                        self_insurance_excess:
                            this.data.self_insurance_excess,
                        insured_icds: this.data.insured_icds,
                    },
                    headersToken(this.login.token),
                );

                this.$swal.fire(
                    msgAlert(
                        response.data.success ? "success" : "error",
                        response.data.message,
                    ),
                );

                if (response.data.success) {
                    this.dialog = false;
                    this.$emit("updated");
                }
            } catch (err) {
                this.$swal.fire(
                    msgAlert(
                        "error",
                        "No fue posible actualizar el exceso de autoseguro",
                    ),
                );
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>